import ArticleLayout from '@/components/feature/ArticleLayout';

const pageData = {
  title: 'AllChinaBuy Spreadsheet for Beginners: Start Here',
  description: 'New to AllChinaBuy? This beginner-friendly guide walks you through everything from creating an account to placing your first order using our AllChinaBuy Spreadsheet directory.',
  image: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20photography%20of%20a%20clean%20desk%20with%20open%20notebook%20pen%20and%20smartphone%20displaying%20shopping%20app%20on%20cream%20white%20surface%2C%20soft%20natural%20lighting%2C%20editorial%20style%2C%20warm%20neutral%20tones&width=1200&height=600&seq=art-beginners-guide-2026&orientation=landscape',
  imageAlt: 'AllChinaBuy Beginners Guide 2026',
  category: 'Beginners',
  readTime: '7 min read',
  dateLabel: 'Updated June 2026',
  schemaData: {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: 'AllChinaBuy Spreadsheet for Beginners 2026',
    description: 'Beginner-friendly guide to AllChinaBuy. Create account, place first order, use the spreadsheet directory.',
    datePublished: '2026-06-05',
    dateModified: '2026-06-25',
    author: { '@type': 'Organization', name: 'AllChinaBuySpreadsheet.ink' },
    publisher: { '@type': 'Organization', name: 'AllChinaBuySpreadsheet.ink' },
  },
};

export default function BeginnersGuidePage() {
  return (
    <ArticleLayout {...pageData}>
      <section>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-10 mb-4">
          Your First Steps with AllChinaBuy Spreadsheet
        </h2>
        <p className="text-foreground-700 leading-relaxed">
          Welcome to the <strong>AllChinaBuy Spreadsheet</strong>! If you have never shopped on AllChinaBuy before, do not worry — our spreadsheet makes the entire process incredibly simple. The first step is creating an AllChinaBuy account, which takes just a few minutes. Once registered, you can start browsing our spreadsheet of 5,000+ products across 14 categories.
        </p>
        <p className="text-foreground-700 leading-relaxed mt-3">
          Our AllChinaBuy Spreadsheet is designed specifically with beginners in mind. Each category is clearly labeled, every product link goes directly to the item page, and our guides explain every step of the buying process in plain language. You do not need any prior experience to start shopping successfully.
        </p>
      </section>

      <section>
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mt-10 mb-4">
          How to Place Your First AllChinaBuy Order
        </h2>
        <p className="text-foreground-700 leading-relaxed">
          Placing your first order through the AllChinaBuy Spreadsheet is straightforward. Browse the category you are interested in, click any product link to open it on AllChinaBuy, select your preferred size and color, and add the item to your cart. From there, the AllChinaBuy platform guides you through checkout and payment.
        </p>
        <p className="text-foreground-700 leading-relaxed mt-3">
          After placing your order, the seller ships the product to the AllChinaBuy warehouse, where QC photos are taken. Our AllChinaBuy Spreadsheet includes a QC checklist to help you review these photos. Once you approve, your package is shipped internationally to your address. The entire process is safe, transparent, and beginner-friendly.
        </p>
      </section>
    </ArticleLayout>
  );
}